import { render } from "./UserManagementGroupAssignmentDialog.vue?vue&type=template&id=7084d7e6"
import script from "./js/userManagementGroupAssignmentDialog.js?vue&type=script&lang=js&external"
export * from "./js/userManagementGroupAssignmentDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__